/**
 * Single Sends (SMS / email / push one-offs under Messages) — opt-in via env.
 * Set `REACT_APP_SINGLE_SENDS_ENABLED=true` to show nav, routes, delivery shortcuts, and segment usage.
 */
export function isSingleSendsEnabled(): boolean {
  return String(process.env.REACT_APP_SINGLE_SENDS_ENABLED || '').toLowerCase() === 'true';
}

export function useSingleSendsEnabled(): boolean {
  return isSingleSendsEnabled();
}
